import { SgBsThemeContext } from 'contexts/sgBsTheme.context';
import { useContext } from 'react';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

export function useSgBsTheme() {
  return useContext<SgBsTheme>(SgBsThemeContext);
}
